(() => {
  class MoleculeFooter {
    constructor(root) {
      this.root = root;
      this.bind();
    }

    isMobile() {
      return window.matchMedia('(max-width: 767px)').matches;
    }

    bind() {
      this.root.addEventListener('click', (event) => {
        const toggle = event.target.closest('[data-wm-footer-acc-toggle]');
        if (!toggle || !this.root.contains(toggle)) return;
        if (!this.isMobile()) return;
        event.preventDefault();
        this.toggle(toggle.closest('[data-wm-footer-acc]'));
      });

      window.addEventListener('resize', () => {
        if (!this.isMobile()) this.closeAll();
      });
    }

    toggle(acc) {
      if (!acc) return;
      const willOpen = !acc.classList.contains('is-open');
      this.root.querySelectorAll('[data-wm-footer-acc].is-open').forEach((openAcc) => {
        if (openAcc !== acc) this.setOpen(openAcc, false);
      });
      this.setOpen(acc, willOpen);
    }

    setOpen(acc, open) {
      const btn = acc.querySelector('[data-wm-footer-acc-toggle]');
      const panel = acc.querySelector('.wm-footer__menu-panel');
      acc.classList.toggle('is-open', open);
      if (btn) btn.setAttribute('aria-expanded', String(open));
      if (panel) panel.setAttribute('aria-hidden', String(!open));
    }

    closeAll() {
      this.root.querySelectorAll('[data-wm-footer-acc].is-open').forEach((acc) => {
        this.setOpen(acc, false);
      });
    }
  }

  const init = () => {
    document.querySelectorAll('[data-wm-footer]').forEach((el) => {
      if (el.dataset.wmFooterReady) return;
      el.dataset.wmFooterReady = 'true';
      new MoleculeFooter(el);
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
})();
